import { RJSFSchema, RJSFSchemaType } from "shared/types/RJSF"

export function hasSchemaType(
  schema: RJSFSchema,
  type: RJSFSchemaType | RJSFSchemaType[]
) {
  if (Array.isArray(type)) {
    if (Array.isArray(schema.type)) {
      return schema.type.some(t => type.includes(t))
    }
    return schema.type ? type.includes(schema.type) : false
  }
  return Array.isArray(schema.type)
    ? schema.type.includes(type)
    : schema.type === type
}
